import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { nextPage } from 'components/RCPro/helpers/nav'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Turnover.module.scss'
import Turnover from 'components/RCPro/components/form/Turnover/Turnover'
import Checkbox from 'components/common/Checkbox/Checkbox'
import { usePrice } from 'components/RCPro/components/Context/Context'

const RCProTurnover = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const { getPrice } = usePrice()
  const [ unitedStates, setUnitedStates ] = useState(state.unitedStates || false)
  const { turnover, layout } = state.texts

  // Initialize form
  const {
    register,
    formState: { isValid, errors },
    handleSubmit,
    watch
  } = useForm({
    ...formParams,
    values: {
      turnover: state.turnover || '',
    },
  })

  const onSubmit = handleSubmit(async data => {
    const CA = data.turnover.replace(/\D/g, '')
    const { amount, exclusion, sign } = turnover?.exclusion || {}
    let outForMargin = false
    if (exclusion && sign && !isNaN(amount)){
      switch(sign){
        case 'supérieur':
          outForMargin = CA > amount;
          break;
        case 'supérieur égale':
          outForMargin = CA >= amount;
          break;
        case 'inférieur':
          outForMargin = CA < amount;
          break;
        case 'inférieur égale':
          outForMargin = CA <= amount;
          break;
        case 'égale':
          outForMargin = CA === amount;
          break;
        default:
          outForMargin = false
          break;
      }
    }

    const redirect = unitedStates
      ? 'origin'
      : outForMargin
        ? 'high-turnover'
        : CA <= 70000 && state.codeProduct === "TECH"
          ? 'low-turnover'
          : false

    if (redirect) {
      setTimeout( () => {
        navigate('../oups?reason='+redirect, { state: { ...state, turnover: CA } })
      }, 250)
    } else {
      const { codeProduct, activity, token } = state
      getPrice({ codeProduct, turnover: CA, activity, token })
      nextPage({ pathname, state, navigate, data: { turnover: CA } })
    }
    nextPageTransition()
  })

  return (
    <>
      <h1>{turnover?.title} 💸</h1>

      <form onSubmit={onSubmit}>
        <Turnover
          register={register}
          error={errors.turnover}
          value={watch('turnover')}
        />

        <Checkbox
          id="us"
          className={style.checkbox}
          checked={unitedStates}
          label={turnover?.us}
          onChange={() => setUnitedStates(!unitedStates)}
        />

        <Button
          label={<>{layout?.next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProTurnover